import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const BannerContainer = styled.header.withConfig({
  displayName: "SplashPageBanner__BannerContainer",
  componentId: "sc-1930fl6-0"
})(["position:relative;width:100%;height:250px;display:flex;flex-direction:column;justify-content:center;align-items:center;"]);
const SplashPageBanner = ({
  children,
  style
}) => {
  return /*#__PURE__*/_jsx(BannerContainer, {
    style: style,
    children: children
  });
};
export default SplashPageBanner;